import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { CompanyBetaProgramsTabDataProviderFactory } from '../factory/CompanyBetaProgramsTabDataProviderFactory';
import { CompanyBetaProgramsTabBaseDataProvider } from '../dataProvider/CompanyBetaProgramsTabBaseDataProvider';
import { GetBetaProgramsResponse, UpdateEnrollmentStateResponse } from '../types/types';

export class CompanyBetaProgramsTabRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CompanyBetaProgramsTabDataProviderFactory;
  public dataProvider: CompanyBetaProgramsTabBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CompanyBetaProgramsTabDataProviderFactory(),
    });
  }

  public async getAllAvailableBetaPrograms(): Promise<GetBetaProgramsResponse> {
    return await this.dataProvider.getAllAvailableBetaPrograms();
  }

  public async updateEnrollmentState(type: number, state: boolean): Promise<UpdateEnrollmentStateResponse> {
    return await this.dataProvider.updateEnrollmentState(type, state);
  }
}
